/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { styles } from './styles';

const ProgressButton = ({ isLoading, button, circleColor, fullWidth, sx }) => {
	return (
		<Box sx={{ ...styles.wrapper, ...sx }} style={{ width: fullWidth ? '100%' : '' }}>
			{button}
			{isLoading && <CircularProgress color={circleColor || 'primary'} size={24} sx={styles.buttonProgress} />}
		</Box>
	);
};
export default ProgressButton;
